var exports = {
  "Nr": "StreamWatchHoverCard.module__card___c2I4U0",
  "Br": "StreamWatchHoverCard.module__variantCompact___c2I4U0",
  "wy": "StreamWatchHoverCard.module__variantList___c2I4U0",
  "VH": "StreamWatchHoverCard.module__preview___c2I4U0",
  "sf": "StreamWatchHoverCard.module__previewCompact___c2I4U0",
  "$8": "StreamWatchHoverCard.module__previewList___c2I4U0",
  "oz": "StreamWatchHoverCard.module__previewImage___c2I4U0",
  "nZ": "StreamWatchHoverCard.module__previewFallback___c2I4U0",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___c2I4U0",
  "Iq": "StreamWatchHoverCard.module__compactButton___c2I4U0",
  "$l": "StreamWatchHoverCard.module__actionRow___c2I4U0",
  "uu": "StreamWatchHoverCard.module__actionButtons___c2I4U0",
  "jb": "StreamWatchHoverCard.module__listButton___c2I4U0",
  "fX": "StreamWatchHoverCard.module__previewClickable___c2I4U0",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___c2I4U0",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___c2I4U0",
  "z0": "StreamWatchHoverCard.module__protipRow___c2I4U0",
  "cm": "StreamWatchHoverCard.module__protipText___c2I4U0",
};

module.exports = exports;
